
import Vue from "vue";
export default Vue.extend({
  name: "commission",

  data: () => ({
    logo: require("@/assets/images/usmf-logo.png"),
  }),
});
